<template>
    <div class="course-item" style="margin-top: 3rem;height: 100%;">
            <div class="course-title">教学团队</div>
            <el-tooltip effect="dark" content="添加教训团队" placement="top-start">
                <div class="iconfont icon-jia" :class="{'disabled-btn':disabled}" @click="addTeam"></div>
            </el-tooltip>
            <div style="height: calc(100% - 18rem);overflow: auto;padding: 1rem 0;">
                <div v-for="(item, index) in courseTeam" class="team-item" :key="index">
                <i class="iconfont icon-mulu"></i>
                <!-- <i class="iconfont icon-mulu" v-if="index != courseTeam.length - 1"></i>
                <i class="iconfont icon-jia" v-else @click="addTeam"></i> -->
                <div class="item">
                    <div>头像</div>
                    <el-upload :disabled="disabled" style="width: 32px !important; height: 32px !important" action="#"
                        accept=".jpg,.jpeg,.png" list-type="picture-card" :auto-upload="false" :show-file-list="false"
                        :on-change="(e) => { handleFmCover(e, item) }">
                        <img style="width: 30px; height: 30px;object-fit: cover;" class="avatar" :src="$severUrl(item.avatar)"
                            v-if="item.avatar" />
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                </div>
                <div class="item">
                    <div>名称</div>
                    <el-input :disabled="disabled" v-model="item.teacherName" style="margin-top: 2rem;width: 10rem;" placeholder="请输入内容"></el-input>
                </div>
                <div class="item">
                    <div>职务</div>
                    <el-input :disabled="disabled" v-model="item.rank" style="margin-top: 2rem;" placeholder="请输入内容"></el-input>
                </div>
                <div class="item" style="flex: 1;">
                    <div>备注</div>
                    <el-input :disabled="disabled" v-model="item.info" style="margin-top: 2rem;width: 100%"
                        placeholder="请输入内容"></el-input>
                </div>
                <i class="item el-icon-close" @click="delTeam(index)"></i>
            </div>
            </div>
            <div class="save-box">
                <el-button type="primary" :class="{'disabled-btn':disabled}" size="large" v-debounce="save">保存</el-button>
            </div>
        </div>
</template>

<script>
import { GetTeamList,UpdateTeachingTeam } from '@/api/teachTeam';
import { uploadFile } from '@/assets/js/oss';
    export default {
        props:['disabled'],
        data(){
            return {
                courseTeam:[{
                    avatar:'',
                    info:'',
                    rank:'',
                    teacherName:'',
                    teacherId:''
                    }],
            }
        },
        computed:{
            courseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id||'';
            }
        },
        methods:{
             /**新增教学团队 */
             addTeam() {
                if(this.disabled)return;
                this.courseTeam.push({
                    "avatar": "",
                    "info": "",
                    "rank": "",
                    "teacherId": "",
                    "teacherName": ""
                });
            },
            /**上传头像 */
            handleFmCover(e, item) {
                uploadFile(e.raw).then(res => {
                    item.avatar = res.previewUrl;
                })
            },
            /**删除教学团队 */
            delTeam(index) {
                this.courseTeam.splice(index, 1);
            },
            /**课程教学团队查询 */
            selectTeachTeam(){
                GetTeamList({courseId:this.courseId}).then(res=>{
                    if(res.code==200){
                       if(res.data&&res.data.length>0){
                        this.courseTeam=res.data;
                       }
                    }
                })
            },
            /**保存 */
            save(){
                if(this.disabled)return;
                let params={
                    "courseId": this.courseId,
                    "teachingTeamUpdatePOList":this.courseTeam
                };
                UpdateTeachingTeam(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                                showClose: true,
                                message: "保存成功",
                                type: "success",
                            });
                        this.$emit('save_success');
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.team-item {
    display: flex;
    align-items: flex-end;
    margin-top: 2rem;
    &> :nth-child(n){
        margin-right: 1rem;
    }
}
.icon-mulu {
    margin-bottom: 0.7rem;
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    line-height: 2.5rem;
}

.icon-jia {
    display: inline-block;
    border: 1px solid #8590b3;
    border-radius: 6px;
    font-size: 3rem;
    color: #8590B3;
    cursor: pointer;
    margin-top: 2rem;
}
.item {
    /deep/.el-upload {
        width: 32px;
        height: 32px;
        position: relative;
        border: 1px solid #e8ecef;
    }

    /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &> :nth-child(1) {
        color: #8590B3;
        font-size: 12px;
    }

    &> :nth-child(2) {
        margin-top: 2rem;
    }

    i {
        font-size: 1rem;
    }
}
.el-icon-close {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
}
.save-box{
    padding: 3rem;
    text-align: center;
}
</style>